export const NoteIcon = ({ width = "20", height = "20", color = "white" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.667 7.49984H9.58366C8.8933 7.49984 8.33366 8.05948 8.33366 8.74984C8.33366 9.44019 8.8933 9.99984 9.58366 9.99984L10.417 9.99984C11.1073 9.99984 11.667 10.5595 11.667 11.2498C11.667 11.9402 11.1073 12.4998 10.417 12.4998H8.33366M10.0003 6.6665V7.49984M10.0003 12.4998V13.3332M15.0003 9.99984H15.0087M5.00033 9.99984H5.00866M1.66699 6.83317L1.66699 13.1665C1.66699 14.0999 1.66699 14.5666 1.84865 14.9232C2.00844 15.2368 2.2634 15.4917 2.57701 15.6515C2.93353 15.8332 3.40024 15.8332 4.33366 15.8332L15.667 15.8332C16.6004 15.8332 17.0671 15.8332 17.4236 15.6515C17.7372 15.4917 17.9922 15.2368 18.152 14.9232C18.3337 14.5666 18.3337 14.0999 18.3337 13.1665V6.83317C18.3337 5.89975 18.3337 5.43304 18.152 5.07652C17.9922 4.76292 17.7372 4.50795 17.4236 4.34816C17.0671 4.16651 16.6004 4.16651 15.667 4.1665L4.33366 4.1665C3.40024 4.1665 2.93353 4.1665 2.57701 4.34816C2.2634 4.50795 2.00844 4.76292 1.84865 5.07652C1.66699 5.43304 1.66699 5.89975 1.66699 6.83317ZM15.417 9.99984C15.417 10.23 15.2304 10.4165 15.0003 10.4165C14.7702 10.4165 14.5837 10.23 14.5837 9.99984C14.5837 9.76972 14.7702 9.58317 15.0003 9.58317C15.2304 9.58317 15.417 9.76972 15.417 9.99984ZM5.41699 9.99984C5.41699 10.23 5.23044 10.4165 5.00033 10.4165C4.77021 10.4165 4.58366 10.23 4.58366 9.99984C4.58366 9.76972 4.77021 9.58317 5.00033 9.58317C5.23044 9.58317 5.41699 9.76972 5.41699 9.99984Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const PlaneIcon = ({
  width = "20",
  height = "20",
  color = "#1bbb6b",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.7873 2.34423C15.5912 1.51383 16.9196 1.50309 17.7369 2.32038C18.5318 3.11528 18.5466 4.39942 17.7702 5.21242L15.4547 7.63723C15.2732 7.82729 15.1824 7.92232 15.1265 8.03362C15.077 8.13214 15.0475 8.23952 15.0398 8.34951C15.0311 8.47377 15.0607 8.6018 15.1197 8.85787L16.5597 15.0975C16.6203 15.3603 16.6506 15.4918 16.6409 15.6189C16.6322 15.7314 16.6008 15.841 16.5485 15.941C16.4894 16.054 16.394 16.1494 16.2033 16.3401L15.8943 16.6491C15.3892 17.1542 15.1366 17.4068 14.8781 17.4525C14.6524 17.4924 14.4202 17.4376 14.2362 17.301C14.0254 17.1445 13.9125 16.8056 13.6866 16.1279L12.0118 11.1035L9.22402 13.8913C9.05761 14.0577 8.97441 14.1409 8.91875 14.2389C8.86945 14.3257 8.83614 14.4206 8.82041 14.5192C8.80267 14.6305 8.81566 14.7475 8.84165 14.9813L8.99474 16.3592C9.02073 16.5931 9.03372 16.71 9.01597 16.8213C9.00025 16.9199 8.96694 17.0148 8.91764 17.1016C8.86198 17.1996 8.77878 17.2828 8.61237 17.4492L8.44778 17.6138C8.05357 18.008 7.85646 18.2051 7.63742 18.2622C7.4453 18.3123 7.24161 18.2921 7.06304 18.2053C6.85945 18.1064 6.70482 17.8745 6.39557 17.4106L5.08864 15.4502C5.03339 15.3673 5.00576 15.3259 4.97369 15.2883C4.9452 15.2549 4.91412 15.2238 4.88074 15.1953C4.84315 15.1633 4.80171 15.1356 4.71884 15.0804L2.75844 13.7735C2.29456 13.4642 2.06263 13.3096 1.96369 13.106C1.87692 12.9274 1.85675 12.7237 1.90682 12.5316C1.9639 12.3126 2.16101 12.1155 2.55523 11.7212L2.71981 11.5567C2.88622 11.3903 2.96942 11.3071 3.0674 11.2514C3.15421 11.2021 3.24916 11.1688 3.34775 11.1531C3.45903 11.1353 3.57597 11.1483 3.80987 11.1743L5.18769 11.3274C5.42158 11.3534 5.53853 11.3664 5.64981 11.3486C5.74839 11.3329 5.84335 11.2996 5.93015 11.2503C6.02813 11.1946 6.11133 11.1114 6.27774 10.945L9.06551 8.15725L4.04111 6.48245C3.36342 6.25655 3.02457 6.1436 2.86808 5.93285C2.73143 5.74881 2.67661 5.51662 2.71654 5.2909C2.76226 5.03241 3.01482 4.77985 3.51994 4.27473L3.82891 3.96575C4.01966 3.77501 4.11503 3.67963 4.22802 3.62056C4.32803 3.56827 4.43762 3.53684 4.55014 3.52818C4.67727 3.51839 4.80869 3.54871 5.07153 3.60937L11.2875 5.04382C11.5458 5.10343 11.6749 5.13323 11.7996 5.12436C11.92 5.1158 12.0371 5.08119 12.1428 5.02293C12.2523 4.96259 12.3445 4.86736 12.5288 4.67691L14.7873 2.34423Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const BuildingIcon = ({
  width = "20",
  height = "20",
  color = "white",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.8337 9.16667H14.8337C15.7671 9.16667 16.2338 9.16667 16.5903 9.34832C16.9039 9.50811 17.1589 9.76308 17.3187 10.0767C17.5003 10.4332 17.5003 10.8999 17.5003 11.8333V17.5M10.8337 17.5L10.8337 5.16667C10.8337 4.23325 10.8337 3.76654 10.652 3.41002C10.4922 3.09641 10.2372 2.84144 9.92364 2.68166C9.56712 2.5 9.10041 2.5 8.16699 2.5L5.16699 2.5C4.23357 2.5 3.76686 2.5 3.41034 2.68166C3.09674 2.84144 2.84177 3.09641 2.68198 3.41002C2.50033 3.76654 2.50033 4.23325 2.50033 5.16667L2.50033 17.5M18.3337 17.5H1.66699M5.41699 5.83333H7.91699M5.41699 9.16667H7.91699M5.41699 12.5H7.91699"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const ShoppingCartIcon = ({
  width = "20",
  height = "20",
  color = "#161616",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.66699 1.6665L2.75546 1.6665C2.96048 1.6665 3.06299 1.6665 3.14548 1.7042C3.21817 1.73743 3.27978 1.79086 3.32295 1.85813C3.37194 1.93446 3.38644 2.03594 3.41543 2.23889L3.80985 4.99984M3.80985 4.99984L4.68643 11.4427C4.79766 12.2603 4.85328 12.6691 5.04874 12.9768C5.22097 13.2479 5.46789 13.4635 5.75979 13.5976C6.09104 13.7498 6.50361 13.7498 7.32875 13.7498H14.4603C15.2458 13.7498 15.6385 13.7498 15.9595 13.6085C16.2424 13.4839 16.4852 13.283 16.6606 13.0284C16.8594 12.7395 16.9329 12.3537 17.0799 11.5821L18.1829 5.79125C18.2346 5.51968 18.2605 5.38389 18.223 5.27775C18.1901 5.18465 18.1253 5.10624 18.0399 5.05652C17.9427 4.99984 17.8045 4.99984 17.528 4.99984L3.80985 4.99984ZM8.33366 17.4998C8.33366 17.9601 7.96056 18.3332 7.50033 18.3332C7.04009 18.3332 6.66699 17.9601 6.66699 17.4998C6.66699 17.0396 7.04009 16.6665 7.50033 16.6665C7.96056 16.6665 8.33366 17.0396 8.33366 17.4998ZM15.0003 17.4998C15.0003 17.9601 14.6272 18.3332 14.167 18.3332C13.7068 18.3332 13.3337 17.9601 13.3337 17.4998C13.3337 17.0396 13.7068 16.6665 14.167 16.6665C14.6272 16.6665 15.0003 17.0396 15.0003 17.4998Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const CreditCardIcon = ({
  width = "20",
  height = "20",
  color = "#1BBB6B",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3337 8.33317L1.66699 8.33317M9.16699 11.6665H5.00033M1.66699 6.83317L1.66699 13.1665C1.66699 14.0999 1.66699 14.5666 1.84865 14.9232C2.00844 15.2368 2.2634 15.4917 2.57701 15.6515C2.93353 15.8332 3.40024 15.8332 4.33366 15.8332L15.667 15.8332C16.6004 15.8332 17.0671 15.8332 17.4236 15.6515C17.7372 15.4917 17.9922 15.2368 18.152 14.9232C18.3337 14.5666 18.3337 14.0999 18.3337 13.1665V6.83317C18.3337 5.89975 18.3337 5.43304 18.152 5.07652C17.9922 4.76292 17.7372 4.50795 17.4236 4.34816C17.0671 4.16651 16.6004 4.16651 15.667 4.1665L4.33366 4.1665C3.40024 4.1665 2.93353 4.1665 2.57701 4.34816C2.2634 4.50795 2.00844 4.76292 1.84865 5.07652C1.66699 5.43304 1.66699 5.89975 1.66699 6.83317Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const HeartHandIcon = ({
  width = "20",
  height = "20",
  color = "#1BBB6B",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1253_17703)">
          <path
            d="M5.00033 16.7395H7.17557C7.45918 16.7395 7.74106 16.7733 8.016 16.8408L10.3144 17.3993C10.8131 17.5208 11.3326 17.5326 11.8366 17.4347L14.3778 16.9403C15.0491 16.8096 15.6666 16.4881 16.1506 16.0173L17.9486 14.2683C18.462 13.7697 18.462 12.9606 17.9486 12.4611C17.4863 12.0114 16.7543 11.9608 16.2313 12.3422L14.1358 13.871C13.8357 14.0903 13.4706 14.2084 13.095 14.2084H11.0716L12.3595 14.2084C13.0855 14.2084 13.6735 13.6363 13.6735 12.9302V12.6745C13.6735 12.0882 13.2633 11.5769 12.6787 11.4351L10.6908 10.9517C10.3673 10.8732 10.036 10.8336 9.70294 10.8336C8.89894 10.8336 7.44357 11.4993 7.44357 11.4993L5.00033 12.521M1.66699 12.1669L1.66699 17.0002C1.66699 17.4669 1.66699 17.7003 1.75782 17.8786C1.83771 18.0354 1.9652 18.1628 2.122 18.2427C2.30026 18.3336 2.53361 18.3336 3.00033 18.3336H3.66699C4.1337 18.3336 4.36706 18.3336 4.54532 18.2427C4.70212 18.1628 4.8296 18.0354 4.9095 17.8786C5.00033 17.7003 5.00033 17.4669 5.00033 17.0002L5.00033 12.1669C5.00033 11.7002 5.00033 11.4668 4.9095 11.2886C4.8296 11.1318 4.70212 11.0043 4.54532 10.9244C4.36706 10.8336 4.1337 10.8336 3.66699 10.8336H3.00033C2.53362 10.8336 2.30026 10.8336 2.122 10.9244C1.9652 11.0043 1.83771 11.1318 1.75782 11.2886C1.66699 11.4668 1.66699 11.7002 1.66699 12.1669ZM14.3265 2.99378C13.8291 1.95307 12.6825 1.40173 11.5674 1.93388C10.4522 2.46604 9.97716 3.72805 10.444 4.83593C10.7326 5.52062 11.5593 6.85024 12.1487 7.7661C12.3665 8.1045 12.4754 8.2737 12.6345 8.37268C12.7709 8.45758 12.9417 8.50334 13.1023 8.49803C13.2896 8.49184 13.4685 8.39976 13.8263 8.2156C14.7947 7.71717 16.1754 6.97903 16.7677 6.53034C17.7259 5.80434 17.9633 4.46989 17.2459 3.45544C16.5285 2.44099 15.2775 2.34117 14.3265 2.99378Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1253_17703">
            <rect width={width} height={height} fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const MedicalCrossIcon = ({
  width = "20",
  height = "20",
  color = "#1BBB6B",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 3.83333C12.5 3.36662 12.5 3.13327 12.4092 2.95501C12.3293 2.79821 12.2018 2.67072 12.045 2.59083C11.8667 2.5 11.6334 2.5 11.1667 2.5H8.83333C8.36662 2.5 8.13327 2.5 7.95501 2.59083C7.79821 2.67072 7.67072 2.79821 7.59083 2.95501C7.5 3.13327 7.5 3.36662 7.5 3.83333V6.16667C7.5 6.63338 7.5 6.86673 7.40917 7.04499C7.32928 7.20179 7.20179 7.32928 7.04499 7.40917C6.86673 7.5 6.63338 7.5 6.16667 7.5H3.83333C3.36662 7.5 3.13327 7.5 2.95501 7.59083C2.79821 7.67072 2.67072 7.79821 2.59083 7.95501C2.5 8.13327 2.5 8.36662 2.5 8.83333V11.1667C2.5 11.6334 2.5 11.8667 2.59083 12.045C2.67072 12.2018 2.79821 12.3293 2.95501 12.4092C3.13327 12.5 3.36662 12.5 3.83333 12.5H6.16667C6.63338 12.5 6.86673 12.5 7.04499 12.5908C7.20179 12.6707 7.32928 12.7982 7.40917 12.955C7.5 13.1333 7.5 13.3666 7.5 13.8333V16.1667C7.5 16.6334 7.5 16.8667 7.59083 17.045C7.67072 17.2018 7.79821 17.3293 7.95501 17.4092C8.13327 17.5 8.36662 17.5 8.83333 17.5H11.1667C11.6334 17.5 11.8667 17.5 12.045 17.4092C12.2018 17.3293 12.3293 17.2018 12.4092 17.045C12.5 16.8667 12.5 16.6334 12.5 16.1667V13.8333C12.5 13.3666 12.5 13.1333 12.5908 12.955C12.6707 12.7982 12.7982 12.6707 12.955 12.5908C13.1333 12.5 13.3666 12.5 13.8333 12.5H16.1667C16.6334 12.5 16.8667 12.5 17.045 12.4092C17.2018 12.3293 17.3293 12.2018 17.4092 12.045C17.5 11.8667 17.5 11.6334 17.5 11.1667V8.83333C17.5 8.36662 17.5 8.13327 17.4092 7.95501C17.3293 7.79821 17.2018 7.67072 17.045 7.59083C16.8667 7.5 16.6334 7.5 16.1667 7.5L13.8333 7.5C13.3666 7.5 13.1333 7.5 12.955 7.40917C12.7982 7.32928 12.6707 7.20179 12.5908 7.04499C12.5 6.86673 12.5 6.63338 12.5 6.16667V3.83333Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const GamingPadIcon = ({
  width = "20",
  height = "20",
  color = "#1BBB6B",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.00028 9.1665H8.33361M6.66694 7.49984V10.8332M12.5003 9.99984H12.5086M15.0003 8.33317H15.0086M8.70774 4.1665L11.2928 4.1665C13.4802 4.1665 14.5739 4.1665 15.4324 4.58103C16.1882 4.946 16.8162 5.53074 17.2341 6.25866C17.7088 7.08542 17.7867 8.17634 17.9425 10.3582L18.1476 13.2286C18.2481 14.636 17.1334 15.8332 15.7224 15.8332C15.0008 15.8332 14.3165 15.5127 13.8546 14.9583L13.5419 14.5832C13.256 14.24 13.113 14.0684 12.9502 13.9298C12.6089 13.6391 12.1957 13.4456 11.7539 13.3695C11.5432 13.3332 11.3198 13.3332 10.8731 13.3332H9.12741C8.68072 13.3332 8.45737 13.3332 8.24664 13.3695C7.80486 13.4456 7.39167 13.6391 7.05036 13.9298C6.88756 14.0684 6.74457 14.24 6.45861 14.5832L6.14597 14.9583C5.68403 15.5127 4.99973 15.8332 4.27816 15.8332C2.86714 15.8332 1.75245 14.636 1.85298 13.2286L2.05801 10.3582C2.21386 8.17634 2.29178 7.08542 2.76642 6.25866C3.18431 5.53074 3.81231 4.946 4.56816 4.58103C5.42663 4.1665 6.52033 4.1665 8.70774 4.1665Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const GiftIcon = ({ width = "20", height = "20", color = "white" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1253_17709)">
          <path
            d="M10.0003 4.99984L10.0003 18.3332M10.0003 4.99984L7.0539 4.99984C6.61976 4.99984 6.20341 4.82424 5.89643 4.51168C5.58945 4.19912 5.41699 3.7752 5.41699 3.33317C5.41699 2.89114 5.58945 2.46722 5.89643 2.15466C6.20341 1.8421 6.61976 1.6665 7.0539 1.6665C9.34556 1.6665 10.0003 4.99984 10.0003 4.99984ZM10.0003 4.99984H12.9468C13.3809 4.99984 13.7972 4.82424 14.1042 4.51168C14.4112 4.19912 14.5837 3.7752 14.5837 3.33317C14.5837 2.89114 14.4112 2.46722 14.1042 2.15466C13.7972 1.8421 13.3809 1.6665 12.9468 1.6665C10.6551 1.6665 10.0003 4.99984 10.0003 4.99984ZM16.667 9.1665V15.6665C16.667 16.5999 16.667 17.0666 16.4853 17.4232C16.3255 17.7368 16.0706 17.9917 15.757 18.1515C15.4005 18.3332 14.9337 18.3332 14.0003 18.3332L6.00033 18.3332C5.0669 18.3332 4.60019 18.3332 4.24367 18.1515C3.93007 17.9917 3.6751 17.7368 3.51531 17.4232C3.33366 17.0666 3.33366 16.5999 3.33366 15.6665L3.33366 9.1665M1.66699 6.33317L1.66699 7.83317C1.66699 8.29988 1.66699 8.53324 1.75782 8.7115C1.83771 8.8683 1.9652 8.99578 2.122 9.07568C2.30026 9.1665 2.53362 9.1665 3.00033 9.1665L17.0003 9.1665C17.467 9.1665 17.7004 9.1665 17.8787 9.07568C18.0355 8.99578 18.1629 8.8683 18.2428 8.7115C18.3337 8.53324 18.3337 8.29988 18.3337 7.83317V6.33317C18.3337 5.86646 18.3337 5.63311 18.2428 5.45485C18.1629 5.29804 18.0355 5.17056 17.8787 5.09067C17.7004 4.99984 17.467 4.99984 17.0003 4.99984L3.00033 4.99984C2.53362 4.99984 2.30026 4.99984 2.122 5.09067C1.9652 5.17056 1.83771 5.29804 1.75782 5.45485C1.66699 5.63311 1.66699 5.86646 1.66699 6.33317Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1253_17709">
            <rect width={width} height={height} fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const GraduationHatIcon = ({
  width = "20",
  height = "20",
  color = "#1BBB6B",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.167 12.0833V9.57866C14.167 9.4291 14.167 9.35431 14.1442 9.28829C14.1241 9.22991 14.0912 9.17673 14.048 9.1326C13.9991 9.08271 13.9322 9.04927 13.7985 8.98238L10.0003 7.08331M3.33366 7.91664L3.33366 13.5888C3.33366 13.8987 3.33366 14.0537 3.38201 14.1894C3.42475 14.3093 3.49441 14.4179 3.58564 14.5067C3.68884 14.6072 3.82972 14.6718 4.11145 14.8009L9.44479 17.2454C9.64915 17.339 9.75133 17.3859 9.85778 17.4043C9.9521 17.4207 10.0485 17.4207 10.1429 17.4043C10.2493 17.3859 10.3515 17.339 10.5559 17.2454L15.8892 14.8009C16.1709 14.6718 16.3118 14.6072 16.415 14.5067C16.5062 14.4179 16.5759 14.3093 16.6186 14.1894C16.667 14.0537 16.667 13.8987 16.667 13.5888V7.91664M1.66699 7.08331L9.70218 3.06571C9.8115 3.01105 9.86616 2.98372 9.92349 2.97297C9.97427 2.96344 10.0264 2.96344 10.0772 2.97297C10.1345 2.98372 10.1891 3.01105 10.2985 3.06571L18.3337 7.08331L10.2985 11.1009C10.1891 11.1556 10.1345 11.1829 10.0772 11.1936C10.0264 11.2032 9.97427 11.2032 9.92349 11.1936C9.86616 11.1829 9.8115 11.1556 9.70218 11.1009L1.66699 7.08331Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const WavyNoteIcon = ({
  width = "20",
  height = "20",
  color = "#1bbb6b",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.00033 9.16683L5.00033 12.5002M15.0003 7.50016L15.0003 10.8335M14.167 3.3335C16.2076 3.3335 17.3113 3.6458 17.8604 3.88803C17.9336 3.92029 17.9701 3.93642 18.0757 4.03714C18.1389 4.09751 18.2544 4.27466 18.2841 4.3569C18.3337 4.49411 18.3337 4.56911 18.3337 4.71911V13.6761C18.3337 14.4334 18.3337 14.8121 18.2201 15.0067C18.1046 15.2047 17.9932 15.2967 17.7769 15.3728C17.5644 15.4476 17.1353 15.3652 16.2771 15.2003C15.6765 15.0849 14.9641 15.0002 14.167 15.0002C11.667 15.0002 9.16699 16.6668 5.83366 16.6668C3.79307 16.6668 2.68938 16.3545 2.14023 16.1123C2.06709 16.08 2.03053 16.0639 1.92499 15.9632C1.86173 15.9028 1.74626 15.7257 1.71655 15.6434C1.66699 15.5062 1.66699 15.4312 1.66699 15.2812L1.66699 6.32421C1.66699 5.5669 1.66699 5.18825 1.78056 4.99362C1.89608 4.79563 2.00748 4.70359 2.22371 4.62751C2.43627 4.55271 2.86535 4.63515 3.72352 4.80004C4.32417 4.91545 5.03656 5.00016 5.83366 5.00016C8.33366 5.00016 10.8337 3.3335 14.167 3.3335ZM12.0837 10.0002C12.0837 11.1508 11.1509 12.0835 10.0003 12.0835C8.84973 12.0835 7.91699 11.1508 7.91699 10.0002C7.91699 8.84957 8.84973 7.91683 10.0003 7.91683C11.1509 7.91683 12.0837 8.84957 12.0837 10.0002Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const PetIcon = ({ width = "20", height = "20", color = "#1BBB6B" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.67521 13.9585C3.47521 16.3668 5.29188 18.3335 7.70854 18.3335H11.7002C14.4169 18.3335 16.2835 16.1418 15.8335 13.4585C15.3585 10.6418 12.6419 8.3335 9.78354 8.3335C6.68354 8.3335 3.93354 10.8668 3.67521 13.9585Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.72494 6.25016C9.87553 6.25016 10.8083 5.31742 10.8083 4.16683C10.8083 3.01624 9.87553 2.0835 8.72494 2.0835C7.57434 2.0835 6.6416 3.01624 6.6416 4.16683C6.6416 5.31742 7.57434 6.25016 8.72494 6.25016Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.4167 7.24984C15.3371 7.24984 16.0833 6.50364 16.0833 5.58317C16.0833 4.6627 15.3371 3.9165 14.4167 3.9165C13.4962 3.9165 12.75 4.6627 12.75 5.58317C12.75 6.50364 13.4962 7.24984 14.4167 7.24984Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 10.5835C18.1904 10.5835 18.75 10.0239 18.75 9.3335C18.75 8.64314 18.1904 8.0835 17.5 8.0835C16.8096 8.0835 16.25 8.64314 16.25 9.3335C16.25 10.0239 16.8096 10.5835 17.5 10.5835Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.30827 8.91683C4.22874 8.91683 4.97493 8.17064 4.97493 7.25016C4.97493 6.32969 4.22874 5.5835 3.30827 5.5835C2.38779 5.5835 1.6416 6.32969 1.6416 7.25016C1.6416 8.17064 2.38779 8.91683 3.30827 8.91683Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Pointer = ({ width = "8", height = "16", color = "#1BBB6B" }) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 8 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.23516 15.0594C4.17396 15.3042 3.82604 15.3042 3.76484 15.0594L0.970142 3.88057C0.477357 1.90943 1.9682 0 4 0C6.0318 0 7.52264 1.90943 7.02986 3.88057L4.23516 15.0594Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export const BankIcon = ({
  width = "20",
  height = "20",
  color = "#1BBB6B",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.16667 7.50018L4.16667 14.1668M7.91667 7.50018L7.91667 14.1668M12.0833 7.50018L12.0833 14.1668M15.8333 7.50018L15.8333 14.1668M2.5 15.5002L2.5 16.1668C2.5 16.6336 2.5 16.8669 2.59083 17.0452C2.67072 17.202 2.79821 17.3295 2.95501 17.4094C3.13327 17.5002 3.36662 17.5002 3.83333 17.5002H16.1667C16.6334 17.5002 16.8667 17.5002 17.045 17.4094C17.2018 17.3295 17.3293 17.202 17.4092 17.0452C17.5 16.8669 17.5 16.6336 17.5 16.1668V15.5002C17.5 15.0335 17.5 14.8001 17.4092 14.6219C17.3293 14.4651 17.2018 14.3376 17.045 14.2577C16.8667 14.1668 16.6334 14.1668 16.1667 14.1668L3.83333 14.1668C3.36662 14.1668 3.13327 14.1668 2.95501 14.2577C2.79821 14.3376 2.67072 14.4651 2.59083 14.6219C2.5 14.8001 2.5 15.0335 2.5 15.5002ZM9.71076 2.56446L3.54409 3.93483C3.17154 4.01761 2.98527 4.05901 2.84622 4.15918C2.72358 4.24754 2.62727 4.36759 2.56762 4.50648C2.5 4.66395 2.5 4.85477 2.5 5.23641L2.5 6.16685C2.5 6.63356 2.5 6.86691 2.59083 7.04517C2.67072 7.20197 2.79821 7.32946 2.95501 7.40935C3.13327 7.50018 3.36662 7.50018 3.83333 7.50018L16.1667 7.50018C16.6334 7.50018 16.8667 7.50018 17.045 7.40935C17.2018 7.32946 17.3293 7.20197 17.4092 7.04517C17.5 6.86691 17.5 6.63356 17.5 6.16685V5.23641C17.5 4.85477 17.5 4.66395 17.4324 4.50649C17.3727 4.36759 17.2764 4.24754 17.1538 4.15918C17.0147 4.05901 16.8285 4.01762 16.4559 3.93483L10.2892 2.56446C10.1813 2.54047 10.1273 2.52848 10.0728 2.52369C10.0244 2.51945 9.97564 2.51945 9.9272 2.52369C9.87267 2.52848 9.8187 2.54047 9.71076 2.56446Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const CoinInHandIcon = ({
  width = "20",
  height = "20",
  color = "#1BBB6B",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_1165_15334)">
          <path
            d="M11.2739 6.95972C10.7969 7.29979 10.2132 7.49984 9.58268 7.49984C7.97185 7.49984 6.66602 6.194 6.66602 4.58317C6.66602 2.97234 7.97185 1.6665 9.58268 1.6665C10.6268 1.6665 11.5428 2.21519 12.0581 3.03996M4.99935 16.7391H7.17459C7.45821 16.7391 7.74009 16.7729 8.01503 16.8404L10.3134 17.3989C10.8121 17.5204 11.3317 17.5322 11.8356 17.4343L14.3768 16.9399C15.0481 16.8092 15.6657 16.4877 16.1496 16.0169L17.9476 14.2679C18.461 13.7693 18.461 12.9602 17.9476 12.4607C17.4853 12.011 16.7533 11.9604 16.2303 12.3418L14.1348 13.8705C13.8348 14.0899 13.4696 14.208 13.0941 14.208H11.0706L12.3586 14.208C13.0845 14.208 13.6726 13.6359 13.6726 12.9298V12.6741C13.6726 12.0878 13.2623 11.5765 12.6777 11.4347L10.6898 10.9513C10.3663 10.8728 10.035 10.8332 9.70197 10.8332C8.89796 10.8332 7.44259 11.4989 7.44259 11.4989L4.99935 12.5206M16.666 5.4165C16.666 7.02733 15.3602 8.33317 13.7493 8.33317C12.1385 8.33317 10.8327 7.02733 10.8327 5.4165C10.8327 3.80567 12.1385 2.49984 13.7493 2.49984C15.3602 2.49984 16.666 3.80567 16.666 5.4165ZM1.66602 12.1665L1.66602 16.9998C1.66602 17.4665 1.66602 17.6999 1.75684 17.8782C1.83674 18.035 1.96422 18.1624 2.12102 18.2423C2.29928 18.3332 2.53264 18.3332 2.99935 18.3332H3.66602C4.13273 18.3332 4.36608 18.3332 4.54434 18.2423C4.70114 18.1624 4.82863 18.035 4.90852 17.8782C4.99935 17.6999 4.99935 17.4665 4.99935 16.9998L4.99935 12.1665C4.99935 11.6998 4.99935 11.4664 4.90852 11.2882C4.82863 11.1314 4.70114 11.0039 4.54434 10.924C4.36608 10.8332 4.13273 10.8332 3.66602 10.8332L2.99935 10.8332C2.53264 10.8332 2.29928 10.8332 2.12102 10.924C1.96422 11.0039 1.83674 11.1314 1.75684 11.2882C1.66602 11.4664 1.66602 11.6998 1.66602 12.1665Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1165_15334">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export const ShoppingBagIcon = ({
  width = "20",
  height = "20",
  color = "#1BBB6B",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.6 2.19984L3.3 3.93317C3.04251 4.27648 2.91377 4.44814 2.91676 4.59183C2.91936 4.71687 2.97799 4.83413 3.07646 4.91123C3.18962 4.99984 3.40419 4.99984 3.83333 4.99984L16.1667 4.99984C16.5958 4.99984 16.8104 4.99984 16.9235 4.91123C17.022 4.83413 17.0806 4.71687 17.0832 4.59183C17.0862 4.44814 16.9575 4.27649 16.7 3.93317L15.4 2.19984M4.6 2.19984C4.74667 2.00428 4.82 1.9065 4.91294 1.83598C4.99525 1.77352 5.08846 1.72692 5.18782 1.69854C5.3 1.6665 5.42222 1.6665 5.66667 1.6665L14.3333 1.6665C14.5778 1.6665 14.7 1.6665 14.8122 1.69854C14.9115 1.72692 15.0047 1.77352 15.0871 1.83598C15.18 1.9065 15.2533 2.00428 15.4 2.19984M4.6 2.19984L3.03333 4.28872C2.83545 4.55257 2.73651 4.68449 2.66625 4.82977C2.6039 4.95869 2.55843 5.0951 2.53096 5.23564C2.5 5.39401 2.5 5.55892 2.5 5.88872L2.5 15.6665C2.5 16.5999 2.5 17.0666 2.68166 17.4232C2.84144 17.7368 3.09641 17.9917 3.41002 18.1515C3.76654 18.3332 4.23325 18.3332 5.16667 18.3332L14.8333 18.3332C15.7668 18.3332 16.2335 18.3332 16.59 18.1515C16.9036 17.9917 17.1586 17.7368 17.3183 17.4232C17.5 17.0666 17.5 16.5999 17.5 15.6665V5.88873C17.5 5.55892 17.5 5.39402 17.469 5.23564C17.4416 5.0951 17.3961 4.95869 17.3338 4.82977C17.2635 4.68449 17.1646 4.55257 16.9667 4.28873L15.4 2.19984M13.3333 8.33317C13.3333 9.21722 12.9821 10.0651 12.357 10.6902C11.7319 11.3153 10.8841 11.6665 10 11.6665C9.11594 11.6665 8.2681 11.3153 7.64298 10.6902C7.01786 10.0651 6.66667 9.21722 6.66667 8.33317"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const TruckIcon = ({
  width = "20",
  height = "20",
  color = "#1BBB6B",
}) => {
  return (
    <>
      <>
        <svg
          width={width}
          height={height}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.666 5.8335H13.6137C13.8176 5.8335 13.9195 5.8335 14.0154 5.85652C14.1004 5.87694 14.1817 5.91061 14.2563 5.9563C14.3404 6.00783 14.4124 6.07989 14.5565 6.22402L17.9422 9.60964C18.0863 9.75376 18.1583 9.82583 18.2099 9.90993C18.2556 9.98449 18.2892 10.0658 18.3097 10.1508C18.3327 10.2467 18.3327 10.3486 18.3327 10.5524V12.9168C18.3327 13.3051 18.3327 13.4993 18.2692 13.6524C18.1847 13.8566 18.0224 14.0188 17.8183 14.1034C17.6651 14.1668 17.471 14.1668 17.0827 14.1668M12.916 14.1668H11.666M11.666 14.1668L11.666 6.00016C11.666 5.06674 11.666 4.60003 11.4844 4.24351C11.3246 3.92991 11.0696 3.67494 10.756 3.51515C10.3995 3.3335 9.93277 3.3335 8.99935 3.3335L4.33268 3.3335C3.39926 3.3335 2.93255 3.3335 2.57603 3.51515C2.26243 3.67494 2.00746 3.92991 1.84767 4.24351C1.66602 4.60003 1.66602 5.06674 1.66602 6.00016L1.66602 12.5002C1.66602 13.4206 2.41221 14.1668 3.33268 14.1668M11.666 14.1668H8.33268M8.33268 14.1668C8.33268 15.5475 7.21339 16.6668 5.83268 16.6668C4.45197 16.6668 3.33268 15.5475 3.33268 14.1668M8.33268 14.1668C8.33268 12.7861 7.21339 11.6668 5.83268 11.6668C4.45197 11.6668 3.33268 12.7861 3.33268 14.1668M17.0827 14.5835C17.0827 15.7341 16.1499 16.6668 14.9993 16.6668C13.8488 16.6668 12.916 15.7341 12.916 14.5835C12.916 13.4329 13.8488 12.5002 14.9993 12.5002C16.1499 12.5002 17.0827 13.4329 17.0827 14.5835Z"
            stroke={color}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </>
    </>
  );
};

export const BellIcon = ({
  width = "20",
  height = "20",
  color = "#1BBB6B",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5004 15.8327C12.5004 17.2134 11.3811 18.3327 10.0004 18.3327C8.61966 18.3327 7.50037 17.2134 7.50037 15.8327M11.4975 5.19815C11.8604 4.82322 12.0837 4.31236 12.0837 3.74935C12.0837 2.59876 11.151 1.66602 10.0004 1.66602C8.84978 1.66602 7.91704 2.59876 7.91704 3.74935C7.91704 4.31236 8.14037 4.82322 8.50328 5.19815M2.12272 6.93515C2.11076 5.72569 2.76283 4.59628 3.81623 4.0019M17.878 6.93515C17.89 5.72569 17.2379 4.59628 16.1845 4.0019M15.0004 9.33268C15.0004 8.18341 14.4736 7.08121 13.5359 6.26855C12.5982 5.4559 11.3265 4.99935 10.0004 4.99935C8.67429 4.99935 7.40252 5.4559 6.46484 6.26855C5.52715 7.08121 5.00037 8.18341 5.00037 9.33268C5.00037 11.2342 4.52881 12.6248 3.94042 13.6199C3.26982 14.754 2.93452 15.3211 2.94776 15.4566C2.96291 15.6115 2.9908 15.6604 3.11649 15.7523C3.22635 15.8327 3.7783 15.8327 4.88219 15.8327L15.1185 15.8327C16.2224 15.8327 16.7744 15.8327 16.8843 15.7523C17.0099 15.6604 17.0378 15.6115 17.053 15.4566C17.0662 15.3211 16.7309 14.754 16.0603 13.6199C15.4719 12.6248 15.0004 11.2342 15.0004 9.33268Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const SmallUpArrow = ({
  width = "14",
  height = "14",
  color = "#1BBB6B",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.73366 10.4993L2.91699 9.68268L8.51699 4.08268H3.50033V2.91602H10.5003V9.91602H9.33366V4.89935L3.73366 10.4993Z"
          fill={color}
        />
      </svg>
    </>
  );
};

export const HorizontalDots = ({
  width = "24",
  height = "24",
  color = "#1BBB6B",
  className,
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
export const ConvertIcon = ({
  width = "20",
  height = "20",
  color = "#4A4A4A",
}) => {
  return (
    <>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M16 3l4 4-4 4" />
        <path d="M20 7H4" />
        <path d="M8 21l-4-4 4-4" />
        <path d="M4 17h16" />
      </svg>
    </>
  );
};
